/**
 * SPA route-change `page_view` push. Off unless `NORCE_GTM_PAGE_VIEW=true`.
 *
 * GA4's Enhanced Measurement counts a pageview per hard load only — its "page
 * changes based on browser history events" option is a per-stream setting and
 * is off for gotaplatsensfoto — so client-side navigations go unmeasured
 * without this. Flagged rather than always-on because a template whose
 * container already has its own pageview path (breadandboxers pushes
 * `custom_page_view`) would otherwise double-count.
 */
export default defineNuxtPlugin(() => {
	if (!useRuntimeConfig().public.gtmPageView) return;

	const { pageView } = useGtmEvents();
	const router = useRouter();

	// Seeded with the landing path so the first afterEach does not re-send the
	// pageview the container already fires on DOM Ready.
	let lastPath = router.currentRoute.value.path;

	router.afterEach(async (to) => {
		// Query-only changes (filters, pagination, sort) are not new pages.
		if (to.path === lastPath) return;
		lastPath = to.path;
		// Let the new document title settle before the tag reads it.
		await nextTick();
		pageView();
	});
});
